import React, { useState } from 'react';
import { Create, Instagram, LinkedIn } from '@mui/icons-material';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useRouter } from 'next/router';

import Link from '../../../Layouts/ActiveLink';

import LazyImage from '../../../Layouts/LazyImage';
import Behance from '../../../SvgIcons/Behance';

import style from './style';
import { useAppSelector } from '../../../../hooks';
import ActiveLink from '../../../Layouts/ActiveLink';

interface Props {
  data: any;
  isCourseDashboard?: boolean;
  isEditable?: boolean;
}

const UserDetails = ({ data, isCourseDashboard, isEditable }: Props) => {
  const classes = style();
  const loginDetails = useAppSelector((state) => state.auth);
  const router = useRouter();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      display={{ md: 'flex' }}
      zIndex={1}
      // className={classes.containerBox}
      paddingTop="16px"
      position="relative"
    >
      <Box height="190px" width="200px" margin={{ xs: 'auto', md: 'none' }}>
        {data?.profileMedia && data?.profileMedia[0]?.s3Location.path ? (
          <LazyLoadImage
            className={classes.userImg}
            style={{ height: '190px', width: '200px' }}
            src={`${process.env.NEXT_PUBLIC_ASSETS_2}/${data?.profileMedia[0]?.s3Location.path}`}
          />
        ) : (
          <LazyImage
            sizes={sizes}
            className={classes.userImg}
            sx={{ height: '190px', width: '200px' }}
            alt={data?.firstName + ' ' + data?.lastName}
            // radius={2}
            quality={85}
            src={
              data?.img
                ? `/images/courses/learners/${data?.img}`
                : '/images/icons/man2.png'
            }
          />
        )}
      </Box>

      <Box className={classes.contentBody}>
        {isEditable && (
          <Box {...(styles as any)}>
            <IconButton onClick={handleOpen}>
              <Create color="primary" />
            </IconButton>
          </Box>
        )}
        {isCourseDashboard && (
          <ActiveLink href={`/user-profile?userId=${loginDetails.userId}`}>
            <Button
              className={classes.floatBtn}
              variant="contained"
              style={{ background: '#5925DC' }}
            >
              View Profile
            </Button>
          </ActiveLink>
        )}
        <Typography variant="h4" component="h1" className="mb-9">
          {data?.firstName + ' ' + data?.lastName}
        </Typography>
        <Typography variant="subtitle1" paragraph className="line-height1-2">
          {data?.designation} <br />
          {data?.country?.label}
        </Typography>
        {/* <Typography variant="subtitle1" paragraph>
          
        </Typography> */}

        {data?.social && (
          <Box
            display="flex"
            maxWidth="211px"
            alignItems="center"
            width="100%"
            className={classes.socialBox}
          >
            {data?.social?.insta && (
              <Link
                href={data?.social?.insta}
                className={classes.anchorTag}
                target="_blank"
              >
                <Instagram fontSize="large" />
              </Link>
            )}{' '}
            {data?.social?.linkedin && (
              <Link href={data?.social?.linkedin} target="_blank">
                <LinkedIn fontSize="large" />
              </Link>
            )}
            {data?.social?.behance && (
              <Link href={data?.social?.behance} target="_blank">
                <Behance fontSize="2.5rem" color="#65a6ff" />
              </Link>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

const sizes = {
  xxl: [216, 190, false],
};

export default UserDetails;

const styles = {
  borderRadius: '50%',
  bgcolor: 'rgba(255, 255, 255, 0.53)',
  position: 'absolute',
  top: 12,
  right: 156,
  '&  .MuiIconButton-label': {
    display: 'flex',
    alignItems: 'center',
    justiyContent: 'center',
  },
};
